// Utils
import { assert } from 'ezyvet-fe-helpers';
/**
 * Derive a list of array changes from two given arrays to move `oldArray` to `newArray`
 *
 * @param {any[]} oldArray
 * @param {any[]} newArray
 *
 * @return {ArrayChanges}
 */
export var deriveArrayChanges = function (oldArray, newArray) {
    assert(Array.isArray(oldArray), 'Argument 1 should be an array');
    assert(Array.isArray(newArray), 'Argument 2 should be an array');
    var changes = {
        order: [],
        remove: [],
    };
    newArray.forEach(function (value, index) {
        var beforeElement;
        if (index > 0) {
            beforeElement = newArray[index - 1];
        }
        var oldPosition = oldArray.indexOf(value);
        var oldBeforeElement;
        if (oldPosition > 0) {
            oldBeforeElement = oldArray[oldPosition - 1];
        }
        if (beforeElement !== oldBeforeElement
            || (beforeElement === undefined && oldPosition === -1)) {
            changes.order.push({
                after: beforeElement,
                value: value,
            });
        }
    });
    oldArray.forEach(function (value) {
        var newIndex = newArray.indexOf(value);
        if (newIndex === -1) {
            changes.remove.push(value);
        }
    });
    return changes;
};
//# sourceMappingURL=deriveArrayChanges.js.map